var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-modal", {
        attrs: {
          id: _vm.id,
          centered: "",
          static: true,
          "return-focus": _vm.nonExistentFocusTargetForClose
        },
        on: {
          shown: function($event) {
            return _vm.focus()
          }
        },
        scopedSlots: _vm._u([
          {
            key: "modal-header",
            fn: function(ref) {
              var close = ref.close
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ContinuousReport.TargetGroupsAndOperation.AddTargetGroups"
                      )
                    )
                  )
                ])
              ]
            }
          },
          {
            key: "default",
            fn: function() {
              return [
                _vm.hasTargetGroups
                  ? _c(
                      "div",
                      [
                        _c(
                          "label",
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "ContinuousReport.TargetGroupsAndOperation.SelectTargetGroups"
                                  )
                                ) +
                                "\n          "
                            ),
                            _c("tooltip-icon", {
                              attrs: {
                                content: _vm.$t(
                                  "ContinuousReport.TargetGroupsAndOperation.SelectTargetGroups_Instructions"
                                )
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.sortedTargetGroups, function(targetGroup) {
                          return _c(
                            "div",
                            {
                              key: _vm.getInputId(targetGroup),
                              staticClass: "mt-2 mb-4"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedGroups,
                                    expression: "selectedGroups"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: targetGroup.name,
                                  id: _vm.getInputId(targetGroup),
                                  disabled: _vm.checkboxDisabled(targetGroup)
                                },
                                domProps: {
                                  value: targetGroup,
                                  checked: Array.isArray(_vm.selectedGroups)
                                    ? _vm._i(_vm.selectedGroups, targetGroup) >
                                      -1
                                    : _vm.selectedGroups
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.selectedGroups,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = targetGroup,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectedGroups = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectedGroups = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectedGroups = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "d-inline-block align-top w-85",
                                  staticStyle: { "white-space": "pre-wrap" },
                                  attrs: { for: _vm.getInputId(targetGroup) }
                                },
                                [_vm._v(_vm._s(targetGroup.name))]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { attrs: { for: _vm.id + "-add" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "ContinuousReport.TargetGroupsAndOperation.NewTargetGroup"
                            )
                          ) +
                          "\n          "
                      ),
                      _c("tooltip-icon", {
                        attrs: {
                          content: _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.NewTargetGroup_Instructions"
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.targetGroupValue,
                        expression: "targetGroupValue"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: _vm.id + "-add",
                      type: "text",
                      maxlength: "50",
                      placeholder: _vm.$t("Placeholder.TextArea"),
                      disabled: _vm.maxSelected
                    },
                    domProps: { value: _vm.targetGroupValue },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.confirm($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.targetGroupValue = $event.target.value
                      }
                    }
                  })
                ])
              ]
            },
            proxy: true
          },
          {
            key: "modal-footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "mt-2 btn btn-secondary",
                    attrs: { type: "button", id: _vm.id + "-dialog" },
                    on: { click: _vm.confirm }
                  },
                  [_vm._v("\n        Ok\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "mt-2 btn btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.cleanAndClose }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("Btn_Cancel")) + "\n      "
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }